/*============================================================================
  Collection page quick-add modal (multi-variant products)
==============================================================================*/
(function($) {
  if (typeof $ === 'undefined') return;

  var $root = $('#collectionQuickAdd');
  if (!$root.length) return;

  var moneyFormat = $root.data('money-format') || (typeof window.moneyFormat !== 'undefined' ? window.moneyFormat : '${{amount}}');

  var $loading = $root.find('.collection-quick-add__loading');
  var $body = $root.find('.collection-quick-add__body');
  var $error = $root.find('.collection-quick-add__error');
  var $title = $('#collectionQuickAddTitle');
  var $form = $root.find('.js-collection-quick-add-form');
  var $select = $('#collectionQuickAddVariant');
  var $price = $('#collectionQuickAddPrice');
  var $viewLink = $root.find('.collection-quick-add__view-product');
  var $submit = $form.find('button[type="submit"]');

  var currentProduct = null;
  var previousFocus = null;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function fetchProduct(handle, done, fail) {
    $.getJSON('/products/' + encodeURIComponent(handle) + '.js')
      .done(done)
      .fail(fail);
  }

  function openModal() {
    $root.addClass('is-visible').attr('aria-hidden', 'false');
    $('body').addClass('collection-quick-add-open');
    $(document).on('keyup.collectionQuickAdd', function(e) {
      if (e.keyCode === 27) closeModal();
    });
  }

  function closeModal() {
    $root.removeClass('is-visible').attr('aria-hidden', 'true');
    $('body').removeClass('collection-quick-add-open');
    $(document).off('keyup.collectionQuickAdd');
    $loading.show();
    $body.hide();
    $error.hide().empty();
    currentProduct = null;
    $select.empty();
    if (previousFocus && previousFocus.focus) {
      try {
        previousFocus.focus();
      } catch (err) { /* ignore */ }
    }
  }

  function showFetchError() {
    $loading.hide();
    $body.hide();
    $error.text('Unable to load product. Please try again.').show();
  }

  function updatePrice(variant) {
    if (!variant) return;
    $price.html(formatMoney(variant.price));
  }

  function populateProduct(product) {
    currentProduct = product;
    $title.text(product.title);
    $viewLink.attr('href', '/products/' + product.handle);

    $select.empty();

    var firstAvailable = null;
    (product.variants || []).forEach(function(v) {
      var label = v.title + ' — ' + formatMoney(v.price);
      if (!v.available) {
        label += ' (Sold out)';
      }
      var $opt = $('<option></option>')
        .val(String(v.id))
        .text(label)
        .prop('disabled', !v.available);
      $select.append($opt);
      if (v.available && !firstAvailable) {
        firstAvailable = v;
      }
    });

    if (firstAvailable) {
      $select.val(String(firstAvailable.id));
      updatePrice(firstAvailable);
      $submit.prop('disabled', false).removeClass('disabled');
    } else {
      $price.empty();
      $submit.prop('disabled', true).addClass('disabled');
    }

    $loading.hide();
    $body.show();
  }

  $(document).on('click', '.js-quick-add-open', function(e) {
    e.preventDefault();
    var handle = $(this).data('product-handle');
    if (!handle) return;

    previousFocus = this;
    openModal();
    $title.text($(this).data('product-title') || '');
    $loading.show();
    $body.hide();
    $error.hide().empty();

    fetchProduct(
      handle,
      function(product) {
        populateProduct(product);
        setTimeout(function() {
          try {
            $select.focus();
          } catch (err) { /* ignore */ }
        }, 50);
      },
      function() {
        showFetchError();
      }
    );
  });

  $select.on('change', function() {
    var id = parseInt($(this).val(), 10);
    if (!currentProduct || !currentProduct.variants) return;
    var v = null;
    for (var i = 0; i < currentProduct.variants.length; i++) {
      if (currentProduct.variants[i].id === id) {
        v = currentProduct.variants[i];
        break;
      }
    }
    if (v) updatePrice(v);
  });

  $root.on('click', '.js-collection-quick-add-close', function(e) {
    e.preventDefault();
    closeModal();
  });

  $(document).on('collectionQuickAdd:added', function(e, form) {
    if (form && $(form).closest('#collectionQuickAdd').length) {
      closeModal();
    }
  });

})(jQuery);
